<template>
  <img class="h-full mx-auto" src="~/assets/Teslemetry.svg" />
</template>
